<ix-form
  [formGroup]="form"
  [isEditMode]="true"
  [submitHandler]="handleSubmit"
  (closed)="closed.emit($event)"
>
  <tn-form-section [heading]="'GUI' | translate">
    <tn-form-field
      [tooltip]="'Automatically switch to the preferred theme based on the OS appearance' | translate"
    >
      <tn-checkbox
        formControlName="syncThemeWithOS"
        [label]="'Sync Theme With OS' | translate"
      ></tn-checkbox>
    </tn-form-field>
    @if (!isSyncWithOs()) {
      <tn-form-field [label]="'Theme' | translate" [required]="true">
        <tn-select
          formControlName="theme"
          [options]="themeOptions"
        ></tn-select>
      </tn-form-field>
    } @else {
      <tn-form-field [label]="'Light Theme' | translate" [required]="true">
        <tn-select
          formControlName="lightTheme"
          [options]="lightThemeOptions"
        ></tn-select>
      </tn-form-field>
      <tn-form-field [label]="'Dark Theme' | translate" [required]="true">
        <tn-select
          formControlName="darkTheme"
          [options]="darkThemeOptions"
        ></tn-select>
      </tn-form-field>
    }
    <tn-form-field
      [label]="'Session Timeout (minutes)' | translate"
      [hint]="sessionTimeoutHint()"
      [tooltip]="'Time in minutes after which the current user session will be disconnected. Interacting with the UI extends the session.' | translate"
    >
      <tn-input
        id="session-timeout"
        formControlName="token_lifetime"
        [inputType]="InputType.Number"
        [allowDecimals]="false"
      ></tn-input>
    </tn-form-field>
  </tn-form-section>

  <tn-form-section [heading]="'Localization' | translate">
    <tn-form-field [label]="'Language' | translate" [required]="true">
      <tn-autocomplete
        formControlName="language"
        [testId]="'language'"
        [options]="languageOptions()"
        [requireSelection]="true"
      ></tn-autocomplete>
    </tn-form-field>
    <tn-form-field [label]="'Date Format' | translate">
      <tn-select
        formControlName="date_format"
        [options]="dateFormatOptions()"
      ></tn-select>
    </tn-form-field>
    <tn-form-field [label]="'Time Format' | translate">
      <tn-select
        formControlName="time_format"
        [options]="timeFormatOptions()"
      ></tn-select>
    </tn-form-field>
  </tn-form-section>
</ix-form>
